import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { ThemeType } from '../Header/types';
import { initialState } from './slice';

const selectLogin = (state: RootState) => state?.authState || initialState;

export const selectIsAuthenticated = createSelector(
  [selectLogin],
  authState => authState?.isAuthenticated,
);

export const selectUserProfile = createSelector(
  [selectLogin],
  authState => authState?.userProfile,
);

export const selectUserPermissions = createSelector(
  [selectLogin],
  authState => authState?.userPermissions,
);

export const selectUserPreferences = createSelector(
  [selectLogin],
  authState => authState?.userPreferences,
);

export const selectAuthDetails = createSelector(
  [selectLogin],
  authState => authState?.authDetails,
);

export const selectUserCDNs = createSelector(
  [selectLogin],
  authState => authState?.userCDNs,
);

export const selectTenantID = createSelector(
  [selectLogin],
  authState => authState?.userProfile?.tenantId,
);

export const selectTenant = createSelector(
  [selectLogin],
  authState => authState?.tenant,
);

export const selectIsProcessing = createSelector(
  [selectLogin],
  authState => authState?.processing,
);

export const selectIsFetchingPermissions = createSelector(
  [selectLogin],
  authState => authState?.fetchingPermissions,
);

export const selectErrorMessage = createSelector(
  [selectLogin],
  authState => authState?.error,
);

export const selectSelectedTab = createSelector(
  [selectLogin],
  authState => authState?.selectedTab,
);

export const selectOperatorPulseDispatch = createSelector(
  [selectLogin],
  authState => authState.operatorPulseDispatch,
);

export const selectTheme = createSelector(
  [selectLogin],
  authState => authState.userPreferences.themeMode ?? ThemeType.DARK,
);

export const selectGoogleConfigSettings = createSelector(
  [selectLogin],
  authState => authState.tenant.googleConfiguration,
);

export const selectAuthParams = createSelector(
  [selectUserProfile],
  userProfile => ({
    accessToken: userProfile.accessToken,
    tenantId: userProfile.tenantId,
  }),
);
